import React, { useEffect, useState } from "react";
import DynamicFormModal from "./DynamicFormModal";
import ComplaintPageServices from "../../../../services/ComplaintPageServices";
import Icons from "../../../../components/UI/Icons";
import TableGrid from "../../../../components/UI/TableGrid"; // Make sure this import is correct
import DropDownService from "../../../../services/DropDownService";
import { convertUnderScoreStrings, toQueryString } from "../../../../utils/commonUtils";
import VisitDetails from "../../../EmployeeVisitContainer/VisitDetails";
// import StatusBar from "../../../EmployeeVisitContainer/NewEmployeeVisitDetailView/RightContent/PhysicalTab/StatusBar";
import { capitalizeFirstLetter } from "../../../../utils/commonUtils";
import Buttons from "../../../../components/UI/Buttons";
import IncidentService from "../../../../services/IncidentService";
import EmrStatusBar from "./EmrStatusBar";
import EmrVisitsService from "../../../../services/EmrVisitsService";

const ComplaintPage = (props) => {
 const [orderCounts, setOrderCounts] = useState({
  ready: { total: 0, labs: 0, xrays: 0, others: 0 },
  pending: { total: 0, labs: 0, xrays: 0, others: 0 },
  completed: { total: 0, labs: 0, xrays: 0, others: 0 },
});
  // console.log("ComplaintPage props:", props.visit_id);
  const { visit_id, visitDetails, Toast } = props;
  
  // Local state for incident details - fetch directly in this component
  const [incidentDetails, setIncidentDetails] = useState(null);
  const [workStatusSummary, setWorkStatusSummary] = useState(null);
  
  // Format injury locations: remove underscores, initial caps, space after commas
  const formatInjuryLocations = (inputString) => {
    if (!inputString) return "";
    // Replace underscores with spaces
    let formatted = inputString.replace(/_/g, ' ');
    // Ensure space after commas
    formatted = formatted.replace(/,\s*/g, ', ');
    // Capitalize first letter of each word
    formatted = formatted.toLowerCase().split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    return formatted;
  };
  console.log("visitDetails in ComplaintPage", visitDetails);
  console.log("incidentDetails in ComplaintPage", incidentDetails);
  const [unfinished, setUnfinished] = useState(false);
 const [patientStatement, setPatientStatement] = useState("");
  // Modal Config
  const [modalConfig, setModalConfig] = useState({
    open: false,
    title: "",
    fields: [],
    mode: "add", // "add" or "edit"
    formType: "", // "task" or "notes"
    editRow: null,
  });
  const [providerOptions, setProviderOptions] = useState([]);
  const fetchProviders = async () => {
    let provider = await DropDownService.getProvidersDropdownList(null);
    let options = [];

    if (provider && provider.length !== 0) {
      options.push({ label: "Select Provider", value: "" });
      provider?.forEach((itm) => {
        options.push({
          label: `${itm.first_name} ${itm.last_name}`,
          value: itm.provider_id,
        });
      });
    }

    setProviderOptions(options);
    return options; // ✅ Return latest options
  };

  // Table Records
  const worklistHeaders = [
    {
      label: "Appointment Type",
      key: "appointment_type",
      inputType: "TextInput",
    },
    { label: "Task", key: "task", inputType: "TextInput" },
    { label: "User", key: "user", inputType: "TextInput" },
    { label: "Action", key: "action", type: "Actions" },
  ];

  const noteHeaders = [
    { label: "TYPE", key: "type", inputType: "TextInput",},
    {
      label: "STATUS",
      key: "status",
      inputType: "TextInput",
    },
    {
      label: "PROVIDER",
      key: "provider_name",
      inputType: "TextInput",
    },
    {
      label: "DATE OF SERVICES",
      key: "service_date",
      inputType: "Date",
    },
    {
      label: "FINISHED BY",
      key: "finished_by",
      inputType: "TextInput",
    },
    {
      label: "FINISHED DATE",
      key: "finished_date",
      inputType: "Date",
    },
    {
      label: "CREATED DATE",
      key: "created_date",
      inputType: "Date",
    },
    { label: "Action", key: "action", type: "Actions" },
  ];
  const allergiesHeaders = [
    { label: "Allergy Type", key: "label", inputType: "TextInput" },
    { label: "Allergen", key: "value", inputType: "TextInput" },
    { label: "Status", key: "selected_value", inputType: "TextInput" },
  ];
  const familyHistoryHeaders = [
    { label: "Family History", key: "label", inputType: "TextInput" },
    { label: "Condition", key: "value", inputType: "TextInput" },
    { label: "Relation", key: "selected_value", inputType: "TextInput" },
  ];
  const medicationsHeaders = [
    { label: "Medication Type", key: "label", inputType: "TextInput" },
    { label: "Medication Name", key: "value", inputType: "TextInput" },
    { label: "Status", key: "selected_value", inputType: "TextInput" },
  ];
  const problemsHeaders = [
    { label: "Problem", key: "label", inputType: "TextInput" },
    { label: "Problem Name", key: "value", inputType: "TextInput" },
    { label: "Status", key: "selected_value", inputType: "TextInput" },
  ];
  const vitalsHeaders = [
    { label: "Visit Date", key: "visit_date", inputType: "TextInput"   },
    { label: "Height", key: "height_feet", inputType: "TextInput" },
    { label: "Weight", key: "weight", inputType: "TextInput" },
    { label: "Heart Rate", key: "heart_rate", inputType: "TextInput" },
    { label: "Respiratory", key: "respiration", inputType: "TextInput" },
    { label: "Oxygen Saturation", key: "saturation", inputType: "TextInput" },
    { label: "Temperature", key: "temperature", inputType: "TextInput" },
    { label: "Pain Scale", key: "pain_scale", inputType: "TextInput" },
    { label: "Blood Pressure", key: "blood_pressure", inputType: "TextInput" },
  ];
  

  // Table States
  const [worklistTable, setWorklistTable] = useState({
    tableHeaders: worklistHeaders,
    tableRows: { data: [], status: 1000 },
    pagination: {
      page: 1,
      perPage: 10,
      totalRecords: 0,
      sort_by: "appointment_type",
      sort_order: "asc",
      search: {},
    },
  });

  const [notesTable, setNotesTable] = useState({
    tableHeaders: noteHeaders,
    tableRows: { data: [], status: 1000 },
    pagination: {
      page: 1,
      perPage: 10,
      totalRecords: 0,
      sort_by: "type",
      sort_order: "asc",
      search: {},
    },
  });
  const [allergyTable, setAllergyTable] = useState({
    tableHeaders: allergiesHeaders,
    tableRows: { data: [], status: 1000 },
    pagination: {
      page: 1,
      perPage: 10,
      totalRecords: 0,
      sort_by: "service_date",
      sort_order: "desc",
      search: {},
    },
  });
  const [familyHistoryTable, setFamilyHistoryTable] = useState({
    tableHeaders: familyHistoryHeaders,
    tableRows: { data: [], status: 1000 },
    pagination: {
      page: 1,
      perPage: 10,
      totalRecords: 0,
      sort_by: "service_date",
      sort_order: "desc",
      search: {},
    },
  });
  const [medicationsTable, setMedicationsTable] = useState({
    tableHeaders: medicationsHeaders,
    tableRows: { data: [], status: 1000 },
    pagination: {
      page: 1,
      perPage: 10,
      totalRecords: 0,
      sort_by: "service_date",
      sort_order: "desc",
      search: {},
    },
  });
  const [problemTable, setProblemTable] = useState({
    tableHeaders: problemsHeaders,
    tableRows: { data: [], status: 1000 },
    pagination: {
      page: 1,
      perPage: 10,
      totalRecords: 0,
      sort_by: "service_date",
      sort_order: "desc",
      search: {},
    },
  });
  const [vitalsTable, setVitalsTable] = useState({
    tableHeaders: vitalsHeaders,
    tableRows: { data: [], status: 1000 },
    pagination: {
      page: 1,
      perPage: 10,
      totalRecords: 0,
      sort_by: "visit_date",
      sort_order: "desc",
      search: {},
    },
  });
  // Form Fields
  const taskFields = [
    {
      type: "TextInput",
      name: "appointment_type",
      label: "Appointment Type",
      className: "form-control form-control-solid",
      placeholder: "Appointment Type",
    },
    {
      type: "TextInput",
      name: "task",
      label: "Task",
      className: "form-control form-control-solid",
      placeholder: "Task",
    },
    {
      type: "TextInput",
      name: "user",
      label: "User",
      className: "form-control form-control-solid",
      placeholder: "User",
    },
  ];

  const noteFields = [
    {
      type: "TextInput",
      name: "type",
      label: "Type",
      className: "form-control form-control-solid",
      placeholder: "Type",
    },
    {
      type: "SelectSearchList",
      name: "status",
      label: "Status",
      className: "form-control form-control-solid",
      options: [
        { value: "", label: "-Select Status-" },
        { value: "finished", label: "Finished" },
        { value: "unfinished", label: "Unfinished" },
      ],
    },
    {
      type: "SelectSearchList",
      name: "provider_id",
      label: "Provider",
      className: "form-control form-control-solid",
      options: providerOptions,
    },
    {
      type: "Date",
      name: "service_date",
      label: "Date of Services",
      className: "form-control form-control-solid",
    },
    {
      type: "TextInput",
      name: "finished_by",
      label: "Finished By",
      className: "form-control form-control-solid",
      placeholder: "Finished By",
    },
    {
      type: "Date",
      name: "finished_date",
      label: "Finished Date",
      className: "form-control form-control-solid",
    },
    {
      type: "Date",
      name: "created_date",
      label: "Created Date",
      className: "form-control form-control-solid",
    },
  ];
  const handleUnfinishedToggle = () => {
    const newState = !unfinished;
    setUnfinished(newState);
    fetchNotes(newState); // ✅ Send query with new state
  };

  // Fetch Worklist
  const fetchWorklist = async () => {
    try {
      props.Loader(true);
      const res = await ComplaintPageServices.getWorkList(visit_id);
      props.Loader(false);
      const tableData = res.data.map((item) => ({
        rowId: item.worklist_id,
        data: {
          appointment_type: item.appointment_type,
          task: item.task,
          user: item.user,
          action: [
            {
              className: "btn btn-datatable btn-icon btn-transparent-dark",
              iconType: "Edit",
              title: "Edit",
              clickHandler: () => handleEdit(item, "task"),
            },
            {
              className: "btn btn-datatable btn-icon btn-transparent-dark",
              iconType: "Remove",
              title: "Delete",
              isDelete: true,
              clickHandler: () => handleDelete(item.worklist_id, "task"),
            },
          ],
        },
      }));

      setWorklistTable((prev) => ({
        ...prev,
        tableRows: { type: "default", data: tableData, status: 200 },
        pagination: { ...prev.pagination, totalRecords: res.data.length },
      }));
    } catch (err) {
      console.error("Worklist API error:", err);
      props.Loader(false);
    }
  };

  // Fetch Notes
  const fetchNotes = async (isUnfinished = false) => {
    try {
      props.Loader(true);
      const res = await ComplaintPageServices.getPatientNotes(visit_id, isUnfinished);
      const tableData = res.data.map((item) => ({
        rowId: item.notes_id,
        data: {
          type: item.type,
          status: item.status,
          provider_name: item.provider_name,
          service_date: item.service_date,
          finished_by: item.finished_by,
          finished_date: item.finished_date,
          created_date: item.created_date,
          action: [
            {
              className: "btn btn-datatable btn-icon btn-transparent-dark",
              iconType: "Edit",
              title: "Edit",
              clickHandler: () => handleEdit(item, "notes"),
            },
            {
              className: "btn btn-datatable btn-icon btn-transparent-dark",
              iconType: "Remove",
              title: "Delete",
              isDelete: true,
              clickHandler: () => handleDelete(item.notes_id, "notes"),
            },
          ],
        },
      }));
      props.Loader(false);
      setNotesTable((prev) => ({
        ...prev,
        tableRows: { type: "default", data: tableData, status: 200 },
        pagination: { ...prev.pagination, totalRecords: res.data.length },
      }));
    } catch (err) {
      console.error("Notes API error:", err);
      props.Loader(false);
    }
  };
  // Fetch Allergies
  const fetchAllergies = async () => {
    try {
      const res = await ComplaintPageServices.getAllergies(visit_id);
      const tableData = res.data.map((item) => ({
        rowId: item.id,
        data: {
          label: item.label,
          value: item.value,
          selected_value: item.selected_value,
        },
      }));

      setAllergyTable((prev) => ({
        ...prev,
        tableRows: { type: "default", data: tableData, status: 200 },
        pagination: { ...prev.pagination, totalRecords: res.data.length },
      }));
    } catch (err) {
      console.error("Notes API error:", err);
    }
  };
  // Fetch family history
  const fetchFamilyHistory = async () => {
    try {
      const res = await ComplaintPageServices.getFamilyHistory(visit_id);
      const tableData = res.data.map((item) => ({
        rowId: item.id,
        data: {
          label: item.label,
          value: item.value,
          selected_value: item.selected_value,
        },
      }));

      setFamilyHistoryTable((prev) => ({
        ...prev,
        tableRows: { type: "default", data: tableData, status: 200 },
        pagination: { ...prev.pagination, totalRecords: res.data.length },
      }));
    } catch (err) {
      console.error("Notes API error:", err);
    }
  };
  const fetchMedications = async () => {
    try {
      const res = await ComplaintPageServices.getMedications(visit_id);
      const tableData = res.data.map((item) => ({
        rowId: item.id,
        data: {
          label: item.label,
          value: item.value,
          selected_value: item.selected_value,
        },
      }));

      setMedicationsTable((prev) => ({
        ...prev,
        tableRows: { type: "default", data: tableData, status: 200 },
        pagination: { ...prev.pagination, totalRecords: res.data.length },
      }));
    } catch (err) {
      console.error("Notes API error:", err);
    }
  };
  const fetchProblems = async () => {
    try {
      const res = await ComplaintPageServices.getProblems(visit_id);
      const tableData = res.data.map((item) => ({
        rowId: item.id,
        data: {
          label: item.label,
          value: item.value,
          selected_value: item.selected_value,
        },
      }));

      setProblemTable((prev) => ({
        ...prev,
        tableRows: { type: "default", data: tableData, status: 200 },
        pagination: { ...prev.pagination, totalRecords: res.data.length },
      }));
    } catch (err) {
      console.error("Notes API error:", err);
    }
  };
  const calculatedAge = (value) => {
    // console.log('valuevalue',value);
      if (!value) return null; // Return null if DOB is not set
      
       const today = new Date();
      const birthDate = new Date(value);
      if (isNaN(birthDate.getTime())) {
        return ''; // Return null if DOB is invalid
      }
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }
      
      return age;
  };

  // Helper function to check if a value is out of range and wrap it with conditional styling
  const formatVitalValue = (value, min, max, isUpperBoundOnly = false) => {
    if (value === null || value === undefined || value === '') {
      return value;
    }
    
    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
      return value;
    }
    
    let isOutOfRange = false;
    if (isUpperBoundOnly) {
      // For pain scale: only check upper bound (> 10)
      isOutOfRange = numValue > max;
    } else {
      // For other vitals: check both bounds
      isOutOfRange = numValue < min || numValue > max;
    }
    
    if (isOutOfRange) {
      return {
        value: value,
        attributes: {
          style: { color: 'red', fontWeight: 'bold' }
        }
      };
    }
    
    return value;
  };

  // Helper function to format blood pressure with conditional styling
  const formatBloodPressure = (systolic, diastolic) => {
    const systolicNum = parseFloat(systolic);
    const diastolicNum = parseFloat(diastolic);
    const displayValue = `${systolic || ''}/${diastolic || ''}`;
    
    // Check if either value is out of range (Systolic: 0-139, Diastolic: 0-89)
    const systolicOutOfRange = !isNaN(systolicNum) && (systolicNum < 0 || systolicNum > 139);
    const diastolicOutOfRange = !isNaN(diastolicNum) && (diastolicNum < 0 || diastolicNum > 89);
    
    if (systolicOutOfRange || diastolicOutOfRange) {
      return {
        value: displayValue,
        attributes: {
          style: { color: 'red', fontWeight: 'bold' }
        }
      };
    }
    
    return displayValue;
  };

  const fetchVitals = async () => {
    try {
      const res = await ComplaintPageServices.getVitals(visit_id);
      console.log("vit6alsss",res)
      const tableData = res.data.map((item) => {
        // Format height as "5'11"" (feet'inches")
        let heightDisplay = '';
        if (item.height_feet || item.height_inch) {
          const feet = item.height_feet || '0';
          const inches = item.height_inch || '0';
          heightDisplay = `${feet}'${inches}"`;
        }
        
        return {
          rowId: item.vital_history_id,
          data: {
            visit_date: item.visit_date,
            height_feet: heightDisplay,
            weight: item.weight,
            heart_rate: formatVitalValue(item.heart_rate, 60, 100),
            respiration: formatVitalValue(item.respiration, 12, 20),
            saturation: formatVitalValue(item.saturation, 95, 100),
            temperature: formatVitalValue(item.temperature, 97, 99),
            pain_scale: formatVitalValue(item.pain_scale, 0, 10, true), // Upper bound only (> 10)
            blood_pressure: formatBloodPressure(item.left_bp, item.right_bp),
          },
        };
      });

      setVitalsTable((prev) => ({
        ...prev,
        tableRows: { type: "default", data: tableData, status: 200 },
        pagination: { ...prev.pagination, totalRecords: res.data.length },
      }));
    } catch (err) {
      console.error("Vitals API error:", err);
    }
  };
  // Fetch incident details directly in this component
  const fetchIncidentDetails = async () => {
    if (!visit_id) return;
    
    try {
      const response = await IncidentService.getIncidentById(visit_id);
      if (response && response.incident_id) {
        setIncidentDetails(response);
        setPatientStatement(response?.patient_incident_description || "");
      } else {
        // No incident found - set to null
        setIncidentDetails(null);
        setPatientStatement("");
      }
    } catch (err) {
      console.error("Error fetching incident details:", err);
      setIncidentDetails(null);
      setPatientStatement("");
    }
  };
  const fetchWorkStatusDetails = async () => {
    if (!visit_id) return;

    try {
      const response = await EmrVisitsService.getWorkStatusSummary(visit_id);
      if (response) {
        setWorkStatusSummary(response);
      } else {
        setWorkStatusSummary(null);
      }
    } catch (err) {
      console.error("Error fetching work status summary:", err);
      setWorkStatusSummary(null);
    }
  }

  // Fetch incident details when component mounts or when visit_id changes
  useEffect(() => {
    if (visit_id) {
      fetchIncidentDetails();
    }
  }, [visit_id]);

  useEffect(() => {
    if (visit_id) {
      fetchWorkStatusDetails();
    }
  }, [visit_id]);


  // Update patient statement when incidentDetails changes
  useEffect(() => {
    setPatientStatement(incidentDetails?.patient_incident_description || "");
  }, [incidentDetails]);

  useEffect(() => {
    fetchWorklist();
    fetchNotes(false);
    fetchProviders();
    fetchAllergies();
    fetchFamilyHistory();
    fetchMedications();
    fetchProblems();
    fetchVitals();
    fetchOrderCounts();
  }, []);

  // Refresh all data when refreshEmrTrigger changes (from Start Over)
  useEffect(() => {
    if (props.refreshEmrTrigger !== undefined && props.refreshEmrTrigger > 0) {
      fetchWorklist();
      fetchNotes(false);
      fetchProviders();
      fetchAllergies();
      fetchFamilyHistory();
      fetchMedications();
      fetchProblems();
      fetchVitals();
      fetchOrderCounts();
      // Refresh incident details when refresh trigger changes
      fetchIncidentDetails();
      fetchWorkStatusDetails();
    }
  }, [props.refreshEmrTrigger]);

  // Open Modal
  const handleOpenModal = async (type) => {
    // await fetchProviders();
    setModalConfig({
      open: true,
      title: type === "task" ? "Add Task" : "Add Notes",
      fields: type === "task" ? taskFields : noteFields,
      mode: "add",
      formType: type,
      editRow: null,
    });
  };

  // Edit Handler
  const handleEdit = async (row, type) => {
    try {
      let resData = {};
      let providers = providerOptions;

      // ✅ Fetch latest data based on type
      if (type === "task") {
        const res = await ComplaintPageServices.getWorkListById(
          row.worklist_id
        );
        resData = res.data;
      } else {
        const res = await ComplaintPageServices.getPatientNotesById(
          row.notes_id
        );
        resData = res.data;

        // ✅ Always fetch fresh provider list and use it immediately
        providers = await fetchProviders();
      }

      // ✅ Build fields dynamically AFTER providers are loaded
      const fields =
        type === "task"
          ? taskFields.map((f) => ({
              ...f,
              defaultValue: resData[f.name] || "",
            }))
          : noteFields.map((f) => {
              if (f.name === "provider_id") {
                return {
                  ...f,
                  options: providers, // ✅ Use latest list, not stale state
                  defaultValue: resData.provider_id || "",
                };
              }
              return {
                ...f,
                defaultValue: resData[f.name] || "",
              };
            });

      // ✅ Open modal with correct provider list
      setModalConfig({
        open: true,
        title: `Edit ${type === "task" ? "Task" : "Note"}`,
        fields,
        mode: "edit",
        formType: type,
        editRow: resData,
      });
    } catch (err) {
      console.error("Edit fetch failed:", err);
    }
  };

  // Delete Handler
  const handleDelete = async (id, type) => {
    try {
      if (type === "task") {
        await ComplaintPageServices.deleteWorkList(id);
        fetchWorklist();
      } else {
        await ComplaintPageServices.deletePatientNotes(id);
        fetchNotes();
      }
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const buildPayload = (formData, type, isEdit = false) => {
    console.log("formData in buildPayload", formData);

    if (type === "task") {
      return {
        visit_id,
        appointment_type: formData.appointment_type,
        task: formData.task,
        user: formData.user,
      };
    }

    if (type === "notes") {
      const providerObj = providerOptions.find(
        (p) => p.value === formData.provider_id
      );
      console.log("providerObj", providerObj);
      return {
        visit_id,
        type: formData.type,
        status: formData.status,
        provider_id: formData.provider_id,
        provider_name: providerObj.label,
        service_date: formData.service_date,
        finished_by: formData.finished_by,
        finished_date: formData.finished_date,
        created_date: formData.created_date,
      };
    }
  };

  const handleSubmit = async (formData) => {
    try {
      props.Loader(true);
      const { formType, mode } = modalConfig;
      const payload = buildPayload(formData, formType, mode === "edit");
      console.log("payload", payload);
      if (mode === "add") {
        if (formType === "task") {
          await ComplaintPageServices.createWorkList(payload);
          fetchWorklist();
        } else {
          await ComplaintPageServices.createPatientNotes(payload);
          fetchNotes();
        }
      } else {
        if (formType === "task") {
          await ComplaintPageServices.updateWorkList(
            modalConfig.editRow.worklist_id,
            payload
          );
          fetchWorklist();
        } else {
          await ComplaintPageServices.updatePatientNotes(
            modalConfig.editRow.notes_id,
            payload
          );
          fetchNotes();
        }
      }
      props.Loader(false);
      setModalConfig((prev) => ({ ...prev, open: false }));
    } catch (err) {
      console.error("Submit failed:", err);
      props.Loader(false);
    }
  };
 
const handleSavePatientStatement = async () => {
    if (!visit_id) {
      Toast.error("Visit ID is missing. Cannot save statement.");
      return;
    }

    let savePayload = {
      patient_incident_description: patientStatement,
      visit_id: visit_id,
      type: 'incident',
      current_validation: "tab2",
    };

    // If incident exists, merge existing data
    if (incidentDetails && incidentDetails.incident_id) {
      savePayload = {
        ...incidentDetails,
        patient_incident_description: patientStatement,
        visit_id: visit_id,
        type: 'incident',
        current_validation: "tab2",
      };
    }

    try {
      props.Loader(true);
      let data;
      
      if (incidentDetails && incidentDetails.incident_id) {
        // Update existing incident
        data = await IncidentService.updateIncidentById(
          incidentDetails.incident_id,
          savePayload
        );
      } else {
        // Create new incident
        data = await IncidentService.saveIncident(savePayload);
      }

      if (data && data.status !== "ERROR") {
        Toast.success("Patient Statement saved successfully!");
        // Refresh incident details after saving
        await fetchIncidentDetails();
        // Trigger refresh if parent component has a refresh handler
        if (props.onIncidentDataRefresh) {
          props.onIncidentDataRefresh();
        }
      } else {
        Toast.error(data?.data || "Failed to save Patient Statement.");
      }
    } catch (err) {
      Toast.error("An error occurred while saving the statement!");
      console.error("Save Patient Statement error:", err);
    } finally {
      props.Loader(false);
    }
  };
const fetchOrderCounts = async () => {
    try {
      const response = await EmrVisitsService.ListOrders(visit_id);
      const orders = response.orders || [];
      
      let ready = { total: 0, labs: 0, xrays: 0, others: 0 };
      let pending = { total: 0, labs: 0, xrays: 0, others: 0 };
      let completed = { total: 0, labs: 0, xrays: 0, others: 0 };

      orders.forEach((order) => {
        const status = (order.status || "").toLowerCase();
        const category = (order.category || "").toUpperCase();
        let targetCard;
        // Logic to determine which card the order belongs to
        if (status === "not started") {
          targetCard = ready;
        } else if (status === "passed" || status === "failed") {
          targetCard = completed;
        } else {
          targetCard = pending;
        }
        targetCard.total += 1;
        // Logic to determine sub-count (Labs/Xray/Others)
        if (category === "LAB") {
          targetCard.labs += 1;
        } else if (category === "X_RAY") {
          targetCard.xrays += 1;
        } else {
          targetCard.others += 1;
        }
      });

      setOrderCounts({
        ready,
        pending,
        completed,
      });
    } catch (err) {
      console.error("Error fetching order counts:", err);
    }
  };
  return (
    <div className="sh_innerPortview">
      <div
        className="sh_cardHeader mb-2 rounded-2"
        style={{
          background: "linear-gradient(90deg, #FFF7DC 0%, #F7E9E5 100%)",
        }}
      >
        <div className="d-flex justify-content-center">
          <div className="form-group d-flex mb-0 justify-content-between align-items-center">
            <EmrStatusBar visitDetails={props.visitDetails} />
          </div>
        </div>
      </div>
              <div className="sh_cardHeader px-0">
          <div className="row mb-2">
           <div className="col-lg-4 col-md-6 py-1 col-6">
              <div className="d-flex align-items-center justify-content-between sh_statusIndicatorbox blue-orichid px-4 py-3 rounded-4 shadow-sm">
                {/* Left Section */}
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="sh_statusIndicator bg-white "
                    style={{ width: "56px", height: "56px" }}
                  >
                    {/* Your SVG icon */}
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M7 12H10"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7 16H8"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.9749 14.3V12.6C18.9749 11.9925 18.4824 11.5 17.8749 11.5H15.1249C14.5174 11.5 14.0249 11.9925 14.0249 12.6V14.3"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <rect
                        x="11"
                        y="14.3"
                        width="11"
                        height="7.7"
                        rx="1.98"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.25 18H17.75"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.5 19.25V16.75"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 21H5.5C4.11929 21 3 19.8807 3 18.5V8.37167C3.00001 7.57602 3.31608 6.81296 3.8787 6.25035L6.25038 3.87868C6.81299 3.31607 7.57605 3 8.3717 3H15.5C16.8807 3 18 4.11929 18 5.5V8"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3.02344 8.00006H6.49985C7.32827 8.00006 7.99985 7.32849 7.99985 6.50006V3.02368"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                 {/* center section */}
                  <div>
                    <p className="mb-1 fw-medium text-dark">Ready to Process</p>
                    <h3 className="fw-bold mb-0">{orderCounts.ready.total}</h3>
                  </div>

                {/* Right Section */}
                <div className="text-dark">
                  <p className="mb-1 small order-row">
                    <span className="order-label">Labs</span>
                    <strong className="order-value">{orderCounts.ready.labs}</strong>
                  </p>
                  <p className="mb-1 small order-row">
                    <span className="order-label">Xrays</span>
                    <strong className="order-value">{orderCounts.ready.xrays}</strong>
                  </p>
                  <p className="mb-0 small order-row">
                    <span className="order-label">Others</span>
                    <strong className="order-value">{orderCounts.ready.others}</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 py-1 col-6">
              <div className="d-flex align-items-center justify-content-between sh_statusIndicatorbox pale-purple px-4 py-3 rounded-4 shadow-sm">
                {/* Left Section */}
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="sh_statusIndicator bg-white"
                    style={{ width: "56px", height: "56px" }}
                  >
                    {/* SVG Icon */}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.0052 16.4974C13.0537 17.4984 13.4528 18.4505 14.1327 19.1869C14.6757 19.8176 15.3236 20.3497 16.0479 20.7598C16.6786 21.1116 17.4515 21.0889 18.0604 20.7005C18.7169 20.2809 19.3071 19.7657 19.8117 19.1721C20.5041 18.4432 20.9264 17.4994 21.0086 16.4974C21.0134 15.9013 20.7905 15.3258 20.3854 14.8884C19.9961 14.4643 19.4483 14.2208 18.8726 14.2161C18.1498 14.1656 17.4513 14.4879 17.0207 15.0706L17.007 15.0907L16.9931 15.0706C16.6013 14.5193 15.9609 14.1989 15.2847 14.2161C14.6768 14.2058 14.0907 14.4429 13.6609 14.873C13.2311 15.3031 12.9944 15.8894 13.0052 16.4974Z"
                        stroke="#323232"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.0059 10.0044H17.0075"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.00293 9.7302L7.92231 10.5585L9.77308 8.89185"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.0044 21.009H8.00355C5.24097 21.009 3.00146 18.7695 3.00146 16.0069V8.00355C3.00146 5.24097 5.24097 3.00146 8.00355 3.00146H16.0069C18.7695 3.00146 21.009 5.24097 21.009 8.00355V11.0048"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.00293 14.7324L7.92231 15.5607L9.77308 13.894"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  </div>
                    {/* center section */}
                  <div>
                    <p className="mb-1 fw-medium text-dark">Pending Results</p>
                    <h3 className="fw-bold mb-0">{orderCounts.pending.total}</h3>
                  </div>

                {/* Right Section */}
                <div className="text-dark">
                   <p className="mb-1 small order-row">
                    <span className="order-label">Labs</span>
                    <strong className="order-value">{orderCounts.pending.labs}</strong>
                  </p>
                  <p className="mb-1 small order-row">
                    <span className="order-label">Xrays</span>
                    <strong className="order-value">{orderCounts.pending.xrays}</strong>
                  </p>
                  <p className="mb-0 small order-row">
                    <span className="order-label">Others</span>
                    <strong className="order-value">{orderCounts.pending.others}</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 py-1 col-6">
              <div className="d-flex align-items-center justify-content-between sh_statusIndicatorbox linear_gradient px-4 py-3 rounded-4 shadow-sm">
                {/* Left Section */}
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="sh_statusIndicator bg-white"
                    style={{ width: "56px", height: "56px" }}
                  >
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 18H14"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.979 3H7.021C6.469 3 6.021 3.448 6.021 4V6.378C6.021 6.799 6.154 7.21 6.401 7.551L9.621 12L6.401 16.449C6.154 16.79 6.021 17.201 6.021 17.622V20C6.021 20.552 6.469 21 7.021 21H16.978C17.53 21 17.978 20.552 17.978 20V17.658C17.978 17.214 17.83 16.783 17.558 16.432L14.121 12L17.559 7.567C17.831 7.216 17.979 6.785 17.979 6.341V4C17.979 3.448 17.531 3 16.979 3Z"
                        stroke="#1D2433"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                {/* center section */}
                  <div>
                    <p className="mb-1 fw-medium text-dark">Completed</p>
                    <h3 className="fw-bold mb-0">{orderCounts.completed.total}</h3>
                  </div>

                {/* Right Section */}
                <div className="text-dark">
                   <p className="mb-1 small order-row">
                    <span className="order-label">Labs</span>
                    <strong className="order-value">{orderCounts.completed.labs}</strong>
                  </p>
                  <p className="mb-1 small order-row">
                    <span className="order-label">Xrays</span>
                    <strong className="order-value">{orderCounts.completed.xrays}</strong>
                  </p>
                  <p className="mb-0 small order-row">
                    <span className="order-label">Others</span>
                    <strong className="order-value">{orderCounts.completed.others}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div className="sh_cardBox">

        <div className="sh_cardHeader sh_patietoverviewcard">
          {/* complaint page patient Overview start here */}
          <div className="p-2">
            <h6 className="fw-semibold fs-6 text-dark">Patient Overview</h6>
             <div className="row g-3">
               {/* Patient Name & Vitals */}
                <div className="col-md col-6">
                  <p className="mb-1 small text-muted fs-14">Patient Name</p>
                  <p className="fw-medium text-dark  mb-2">{visitDetails?.employee?.first_name||"-"} {visitDetails?.employee.last_name||"-"}</p>
                  <p className="mb-1 small text-muted fs-14">Vitals</p>
                  <p className="fw-medium text-dark mb-0">-</p>
                </div>
                {/* Injury Location & Body Zone */}
                <div className="col-md col-6 border-start border-2" style={{ borderColor: "#94A0B8" }}>
                  <p className="mb-1 small text-muted fs-14">Injury Location</p>
                  <p className="fw-medium text-dark mb-2">{formatInjuryLocations(incidentDetails?.injury_locations) || "-"}</p>
                  <p className="mb-1 small text-muted fs-14">Body Zone</p>
                  <p className="fw-medium text-dark mb-0">{convertUnderScoreStrings(incidentDetails?.body_zone)}</p>
              </div>
              {/* Nature of Incident & Date */}
              <div className="col-md col-6 border-start border-2" style={{ borderColor: "#94A0B8" }}>
                  <p className="mb-1 small text-muted fs-14">Nature of Incident</p>
                  <p className="fw-medium text-dark  mb-2">{incidentDetails?.nature_of_incident || "-"}</p>
                  <p className="mb-1 small text-muted fs-14">Injury Date</p>
                  <p className="fw-medium text-dark mb-0">{incidentDetails?.date_of_incident || '-'}</p>
              </div>
              {/* Company Info */}
              <div className="col-md col-6 border-start border-2" style={{ borderColor: "#94A0B8" }}>
                  <p className="mb-1 small text-muted fs-14">Company Name</p>
                  <p className="fw-medium text-dark mb-2">{visitDetails?.company?.name || "-"}</p>
                  <p className="mb-1 small text-muted fs-14">Company Phone</p>
                  <p className="fw-medium text-dark mb-0">{visitDetails?.company?.phone || "-"}</p>
              </div>
              {/* Insurance Info */}
              <div className="col-md col-6 border-start border-2" style={{ borderColor: "#94A0B8" }}>
                  <p className="mb-1 small text-muted fs-14">Insurance Name</p>
                  <p className="fw-medium mb-2 text-dark">{workStatusSummary?.incident?.insurance_name || '-'}</p>
                  <p className="mb-1 small text-muted fs-14">Insurance Phone</p>
                  <p className="fw-medium text-dark mb-0"> {workStatusSummary?.incident?.insurance_phone? (workStatusSummary.incident.insurance_phone): '-'}</p>
              </div>
            </div>
              <div className="mt-3">
                  <p className="fw-semibold text-dark fs-6 mb-2">Patient Statement</p>
                      <div className="d-flex gap-2">
                      <input type="text"
                      value={patientStatement} 
                      onChange={(e) => setPatientStatement(e.target.value)}
                      placeholder="Add Statement" 
                      className="form-control rounded-3"
                  />
                <Buttons 
                    className={`btn sh_btnprimary btn-primary`}
                    title={"Accept / Replace"}
                    acl={"any"}
                   clickHandler={handleSavePatientStatement}
                >
                  Accept / Replace
                </Buttons>
               </div>
             </div>
           </div>
     </div>
 <div className="sh_cardBody sh_cardbglight" style={{ padding: "0" }}>
          <div className="row" id="complaintAccordion">
            <div className="col-12 p-2">
                {/* vitals */}
                <div className="card mb-2">
                <div
                  className="d-block sh_accordionnewheadernew sh_accordionheader card-header"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={vitalsTable.tableRows.data?.length > 0 ? "true" : "false"}
                  aria-controls="collapseCardExample"
                  href="#patientoverview9"
                >
                  <h6 className="m-0 text-md mx-2 font-weight-bold">
                    Vitals
                  </h6>
                </div>

                <div
                  className={`collapse ${vitalsTable.tableRows.data?.length > 0 ? "show" : ""}`}
                  id="patientoverview9"
                >
                  <div className="card-body sh_patientoverflowcard px-1 py-0 my-1">
                    <TableGrid
                      hasPagination={false}
                      fetchTableRecords={fetchVitals}
                      {...vitalsTable}
                    />
                  </div>
                </div>
              </div>
              {/* Worklist Card */}
              <div className="card mb-2">
                <div style={{ position: "absolute", right: "1%", top: "5px" }}>
                  <div className="addAction gap-1 d-flex justify-content-end align-items-center">
                    <a
                      className="btn p-2 bg-white sh_btnlight"
                      onClick={() => handleOpenModal("task")}
                    >
                      <Icons type="newEdit" /> Add Task
                    </a>
                    <a
                      className="btn btn-icon  btn-transparent-dark"
                      title="Detail view"
                      style={{ cursor: "pointer" }}
                    >
                      <Icons type="newSettings" />
                    </a>
                  </div>
                </div>

                <div
                  className="d-block sh_accordionnewheadernew sh_accordionheader card-header"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={worklistTable.tableRows.data?.length > 0 ? "true" : "false"}
                  aria-controls="collapseCardExample"
                  href="#patientoverview1"
                >
                  <h6 className="m-0 text-md mx-2 font-weight-bold">
                    Worklist
                  </h6>
                </div>

                <div
                  className={`collapse ${worklistTable.tableRows.data?.length > 0 ? "show" : ""}`}
                  id="patientoverview1"   
                >
                  <div className="card-body  px-1 py-0 my-1">
                    <TableGrid
                      hasPagination={false}
                      fetchTableRecords={fetchWorklist}
                      {...worklistTable}
                    />
                  </div>
                </div>
              </div>
              {/* Notes Card */}
              <div className="card mb-2">
                <div style={{ position: "absolute", right: "1.5%", top: "2px" }}>
                  <div className="addAction d-flex gap-1 justify-content-center align-items-center">
                    <a
                      className="btn p-2 bg-white sh_btnlight"
                      onClick={() => handleOpenModal("notes")}
                      style={{ cursor: "pointer" }}
                    >
                      <Icons type="newEdit" /> Add Notes
                    </a>
                    {/* <a
                      className="btn btn-link p2-light text-dark"
                      style={{ cursor: "pointer" }}
                    >
                     
                    </a> */}
                    <button
                      className={`btn ${unfinished ? "btn-secondary" : "text-dark btn-outline-secondary"}`}
                      onClick={handleUnfinishedToggle}
                    >
                     <Icons type="Filter" /> Unfinished
                    </button>
                    {/* <a
                      className="btn btn-icon px-1 btn-transparent-dark"
                      title="Detail view"
                      style={{ cursor: "pointer" }}
                    >
                      <Icons type="Settings" />
                    </a> */}
                  </div>
                </div>

                <div
                  className="d-block sh_accordionnewheadernew sh_accordionheader card-header"
                data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={notesTable.tableRows.data?.length > 0 ? "true" : "false"}
                  aria-controls="collapseCardExample"
                  href="#patientoverview4"
                >
                  <h6 className="m-0 text-md mx-2 font-weight-bold">
                    Patient Notes
                  </h6>
                </div>

                <div
                  className={`collapse ${notesTable.tableRows.data?.length > 0 ? "show" : ""}`}
                  id="patientoverview4"         
                >
                  <div className="card-body sh_patientoverflowcard px-1 py-0 my-1">
                    <TableGrid
                      hasPagination={false}
                      fetchTableRecords={fetchNotes}
                      {...notesTable}
                    />
                  </div>
                </div>
              </div>
              {/* allergies */}
              <div className="card mb-2">
                <div
                  className="d-block sh_accordionnewheadernew sh_accordionheader card-header"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={allergyTable.tableRows.data?.length > 0 ? "true" : "false"}
                  aria-controls="collapseCardExample"
                  href="#patientoverview5"
                >
                  <h6 className="m-0 text-md mx-2 font-weight-bold">
                    Allergies
                  </h6>
                </div>

                <div
                  className={`collapse ${allergyTable.tableRows.data?.length > 0 ? "show" : ""}`}
                  id="patientoverview5"
                >
                  <div className="card-body sh_patientoverflowcard px-1 py-0 my-1">
                    <TableGrid
                      hasPagination={false}
                      fetchTableRecords={fetchAllergies}
                      {...allergyTable}
                    />
                  </div>
                </div>
              </div>
              {/* Family History */}
              <div className="card mb-2">
                <div
                  className="d-block sh_accordionnewheadernew sh_accordionheader card-header"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={familyHistoryTable.tableRows.data?.length > 0 ? "true" : "false"}
                  aria-controls="collapseCardExample"
                  href="#patientoverview6"
                >
                  <h6 className="m-0 text-md mx-2 font-weight-bold">
                    Family History
                  </h6>
                </div>

                <div
                  className={`collapse ${familyHistoryTable.tableRows.data?.length > 0 ? "show" : ""}`}
                  id="patientoverview6"
                >
                  <div className="card-body sh_patientoverflowcard px-1 py-0 my-1">
                    <TableGrid
                      hasPagination={false}
                      fetchTableRecords={fetchFamilyHistory}
                      {...familyHistoryTable}
                    />
                  </div>
                </div>
              </div>
              {/* Medications */}
              <div className="card mb-2">
                <div
                  className="d-block sh_accordionnewheadernew sh_accordionheader card-header"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={medicationsTable.tableRows.data?.length > 0 ? "true" : "false"}
                  aria-controls="collapseCardExample"
                  href="#patientoverview7"
                >
                  <h6 className="m-0 text-md mx-2 font-weight-bold">
                    Medications
                  </h6>
                </div>

                <div
                  className={`collapse ${medicationsTable.tableRows.data?.length > 0 ? "show" : ""}`}
                  id="patientoverview7"
                >
                  <div className="card-body sh_patientoverflowcard px-1 py-0 my-1">
                    <TableGrid
                      hasPagination={false}
                      fetchTableRecords={fetchMedications}
                      {...medicationsTable}
                    />
                  </div>
                </div>
              </div>
              {/* Problems */}
              <div className="card mb-2">
                <div
                  className="d-block sh_accordionnewheadernew sh_accordionheader card-header"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={problemTable.tableRows.data?.length > 0 ? "true" : "false"}
                  aria-controls="collapseCardExample"
                  href="#patientoverview8"
                >
                  <h6 className="m-0 text-md mx-2 font-weight-bold">
                    Problems
                  </h6>
                </div>

                <div
                  className={`collapse ${problemTable.tableRows.data?.length > 0 ? "show" : ""}`}
                  id="patientoverview8"
                >
                  <div className="card-body sh_patientoverflowcard px-1 py-0 my-1">
                    <TableGrid
                      hasPagination={false}
                      fetchTableRecords={fetchProblems}
                      {...problemTable}
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <DynamicFormModal
          isOpen={modalConfig.open}
          onClose={() => setModalConfig({ ...modalConfig, open: false })}
          title={modalConfig.title}
          fields={modalConfig.fields}
          onSubmit={handleSubmit}
          Loader={props.Loader}
          Toast={props.Toast}
        />
      </div>
    </div>
  );
};

export default ComplaintPage;
